import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import ChangeOrgUser from "@/views/MGT/modal/ChangeOrgUser";
import LineOrgTag from "@/components/FragmentTemplate/LineOrgTag";
import ChangeOrg from "@/views/MGT/modal/ChangeOrg";
import { modMemberDepartmentBatch } from "@/service/structure";
export default {
  name: "BatchUsers",
  components: {
    ChangeOrgUser,
    LineOrgTag,
    ChangeOrg
  },
  data() {
    return {
      modal: {
        visible: false,
        loading: false
      },
      scopeList: [],
      messageScopeList: [],
      popVisible: false,
      nowType: ""
    };
  },
  computed: {
    showUserAdd() {
      return this.scopeList.length === 0 ? true : false;
    },
    showOrgAdd() {
      return !this.nowType;
    },
    showMessageAdd() {
      return this.messageScopeList.length === 0 ? true : false;
    },
    buttonDisabled() {
      return this.scopeList.length > 0 && this.messageScopeList.length > 0;
    }
  },
  methods: {
    open(data) {
      this.modal.visible = true;
      this.onChangeUser(data);
    },
    /* 不显示弹窗 */
    clean() {
      this.scopeList = [];
      this.messageScopeList = [];
      this.popVisible = false;
      this.nowType = "";
      this.modal.visible = false;
    },
    async onCommit() {
      let userIds = this.scopeList.map(v => {
        if (v.userId) {
          return v.userId;
        } else {
          return v.orgId;
        }
      }).join(",");
      let unitId = this.scopeList.map(v => v.unitId).join(",");
      let orgIds = this.messageScopeList.map(v => {
        return v.orgId;
      }).join(",");
      const params = {
        userIds,
        orgIds,
        unitId
      };
      this.modal.loading = true;
      let res = await modMemberDepartmentBatch(params);
      if (res.data && res.data.result === 0) {
        this.$Message.success($t("hiq0dw6", "批量操作成功"));
        this.$emit("update"), this.clean();
      }
      this.modal.loading = false;
    },
    openModal(key, type) {
      switch (key) {
        case "user":
          this.$refs["ChangeOrgUser"].open();
          break;
        case "pop":
          this.popVisible = false;
          this.nowType = type;
          this.$refs["ChangeOrg"].open();
          break;
        case "org":
          this.$refs["ChangeOrg"].open();
          break;
        default:
          break;
      }
    },
    forEachCheckTree(checkTree) {
      checkTree.forEach(v => {
        if (v.userId) {
          v.type = "USER";
        } else if (v.tagId) {
          v.type = "TAG";
        } else {
          v.type = "ORG";
        }
      });
    },
    onChangeUser(checkTree) {
      this.forEachCheckTree(checkTree);
      this.scopeList = checkTree;
    },
    onChangeOrg(checkTree) {
      this.forEachCheckTree(checkTree);
      this.messageScopeList = [...checkTree];
    }
  }
};